import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type PhoneIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const PhoneIcon = ({
  width = 16,
  height = 16,
  color = tokens.colors.brand.gray.DEFAULT,
  ...props
}: PhoneIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13.2236 13.2236"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2429 9.69733L10.4609 8.91533C10.0703 8.52467 9.43694 8.52467 9.04694 8.91533L8.43228 9.53C8.29494 9.66733 8.08694 9.71333 7.90961 9.63533C7.01894 9.24533 6.13894 8.654 5.35428 7.86933C4.57294 7.088 3.98361 6.212 3.59294 5.32467C3.51161 5.14133 3.55894 4.926 3.70094 4.784L4.25161 4.23333C4.69894 3.786 4.69894 3.15333 4.30828 2.76267L3.52628 1.98067C3.00561 1.46 2.16161 1.46 1.64094 1.98067L1.20628 2.41467C0.712278 2.90867 0.506278 3.62133 0.639611 4.328C0.968945 6.07 1.98094 7.97733 3.61361 9.61C5.24628 11.2427 7.15361 12.2547 8.89561 12.584C9.60228 12.7173 10.3149 12.5113 10.8089 12.0173L11.2429 11.5833C11.7636 11.0627 11.7636 10.2187 11.2429 9.69733V9.69733Z"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.26628 3.28467C7.95361 3.27533 8.64428 3.53 9.16894 4.05467"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0543 2.16933C10.0083 1.12333 8.63694 0.6 7.26628 0.6"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.93895 5.95733C9.94828 5.27 9.69361 4.57933 9.16895 4.05467"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0543 2.16933C12.1003 3.21533 12.6236 4.58667 12.6236 5.95733"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
